<template>
  <div class="app-container bj-label-colon">
    <BjDivider
      >基础信息
      <template slot="right"
        ><el-button @click="handleClose">{{ $t('backText') }}</el-button>

        <el-button
          v-if="!isVerify && info.status === 'wait'"
          v-permission:BusinessStockLockIndex_Abandon
          type="danger"
          @click="onStatus('abandon', info)"
          >作废</el-button
        >
        <el-button
          v-if="isVerify && info.status === 'wait'"
          v-permission:BusinessStockVerifyPlanIndex_Pass
          type="primary"
          class="main-btn"
          @click="onStatus('success', info)"
          >审核通过</el-button
        ><el-button
          v-if="isVerify && info.status === 'wait'"
          v-permission:BusinessStockVerifyPlanIndex_Reject
          type="danger"
          @click="onStatus('fail', info)"
          >审核拒绝</el-button
        ></template
      >
    </BjDivider>

    <el-form label-width="130px" class="gray">
      <el-row>
        <el-col :span="8">
          <el-form-item label="预留锁定单号">
            {{ info.reserveCode }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('table.statusText')">
            {{ $t(STOCK_LOCK_STATUS_LIST.bjGet(info.status)) }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="仓库名称">
            {{ info.warehouseName }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="仓库编码">
            {{ info.warehouseCode }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="预计预留总数">
            {{ info.planNum }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="实际预留总数">
            {{ info.realNum }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="锁定生效时间">
            {{ info.auditDate }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('table.createTimeText')">
            {{ info.creationDate }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="创建人">
            {{ info.createdName }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('table.remarkText')">
            {{ info.remark }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <BjDivider>商品明细 </BjDivider>
    <el-table
      ref="multipleTable"
      :data="info.reserveDetailResVOList || []"
      stripe
      border
      :header-cell-style="$rowStyle.DEFAULT"
      row-key="BJ_EBC_ID"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column type="index" width="55" align="center" label="序号" />
      <el-table-column prop="categoryName" label="商品分类" />
      <el-table-column prop="spuCode" label="商品编码" />
      <el-table-column prop="spuName" label="商品名称" />
      <el-table-column prop="skuCode" label="SKU编码" />

      <el-table-column prop="usableNum" label="可预留库存" />
      <el-table-column prop="planNum" label="预计预留数量" />
      <el-table-column prop="actuallyNum" label="实际预留数量" />
    </el-table>
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { stockApi } from '@/api';
import { STOCK_LOCK_STATUS_LIST } from '@/utils/constants';
export default {
  name: 'BusinessStockLockView',
  mixins: [viewMiXin],
  props: {
    isVerify: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      STOCK_LOCK_STATUS_LIST,
      info: {
        code: null,
        id: null,
        moveRecordDetailResVOList: [],
        parentName: null,
        parentWarehouseId: null,
        receiveId: null,
        receiveName: null,
        remark: null,
        supportId: null,
        supportName: null,
        typeCode: null,
      },
    };
  },
  computed: {},
  mounted() {
    this.reFresh();
    this.$store.dispatch('values/getValueList', 'STOCK.RECORD_STATUS');
  },
  methods: {
    reFresh() {
      this.detailApi({ id: this.$route.query.id });
    },

    /* 关闭弹窗 */
    handleClose() {
      this.cancel();
    },
    detailApi(API_DATA) {
      stockApi.detailReserveRecords(API_DATA).then(res => {
        this.info = res;
      });
    },
    onStatus(flag, row) {
      const TEXT = this.STOCK_LOCK_STATUS_LIST.bjGet(flag);
      this.$confirm(`您正在变更状态为 ${TEXT}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            id: row.id,
            status: flag,
          });
        })
        .catch(() => {});
    },
    operationApi(API_DATA) {
      stockApi.statusReserveRecords(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
